import * as borogove from "borogove";
import { Button } from "@chatscope/chat-ui-kit-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress, Menu, MenuItem } from "@mui/material";
import { useEffect, useState, Suspense } from "react";
import { Await, useAsyncValue } from "react-router";
import { faBars } from "@fortawesome/free-solid-svg-icons";

export const CommandMenuInner = ({
	closeMenu,
	addSession,
}: {
	closeMenu: () => void;
	addSession: (name: string, session: Promise<borogove.CommandSession>) => void;
}) => {
	const commands = useAsyncValue() as borogove.Command[];

	useEffect(() => {
		// Force popover to recalculate position
		window.dispatchEvent(new CustomEvent("resize", {}));
	}, [commands]);

	return (
		<>
			{commands.map((command, idx) => (
				<MenuItem
					onClick={() => {
						closeMenu();
						addSession(command.name, command.execute());
					}}
					key={idx}
				>
					{command.name}
				</MenuItem>
			))}
		</>
	);
};

export const CommandMenu = ({
	chat,
	addSession,
}: {
	chat: borogove.Chat;
	addSession: (name: string, session: Promise<borogove.CommandSession>) => void;
}) => {
	const [promise, setPromise] = useState<Promise<borogove.Command[]>>(
		Promise.resolve([]),
	);
	const [key, setKey] = useState(1);
	const [menu, setMenu] = useState<HTMLElement | null>(null);
	const closeMenu = () => {
		setMenu(null);
	};

	return (
		<>
			<Button
				aria-haspopup="menu"
				border
				icon={<FontAwesomeIcon icon={faBars} />}
				onClick={(e) => {
					setMenu(e.currentTarget);
					setPromise(chat.commands());
					setKey(key + 1);
				}}
			>
				Menu
			</Button>
			<Menu
				open={!!menu}
				anchorEl={menu}
				onClose={closeMenu}
				anchorOrigin={{ vertical: "top", horizontal: "left" }}
				transformOrigin={{ vertical: "bottom", horizontal: "left" }}
				slotProps={{ paper: { style: { maxHeight: "21em" } } }}
			>
				<Suspense
					key={key}
					fallback={
						<MenuItem disabled>
							<CircularProgress />
						</MenuItem>
					}
				>
					<Await resolve={promise}>
						<CommandMenuInner closeMenu={closeMenu} addSession={addSession} />
					</Await>
				</Suspense>
			</Menu>
		</>
	);
};
